import { Image } from "@chakra-ui/react";

export const getMaker = (data) => {
  switch (data) {
    case "digikey":
      return "디지키";
    case "mouser":
      return "마우저";
    case "arrow":
      return "애로우";
    case "verical":
      return "베리칼";
    case "onechip":
      return "원칩";
    case "dfrobot":
      return "디에프로봇";
    case "seeed":
      return "씨드";
    case "alliance":
      return "판다파츠";
  }
};

export const logo = (data) => {
  let logo_url = "";
  switch (data.it_maker) {
    case "mouser":
      logo_url = "/images/brand/search/mouser_logo.svg.png";
      break;
    case "digikey":
      logo_url = "/images/brand/search/digikey_logo.png";
      break;
    case "arrow":
      logo_url = "/images/brand/search/arrow_logo.png";
      break;
    case "verical":
      logo_url = "/images/brand/search/verical_logo.png";
      break;
    case "onechip":
      logo_url = "/images/brand/search/onechip_logo.png";
      break;
    case "dfrobot":
      logo_url = "/images/brand/search/dfrobot_logo.png";
      break;
    case "seeed":
      logo_url = "/images/brand/see.png";
      break;
    case "pandaparts":
      logo_url = "/images/brand/search/pandaparts_logo.png";
      break;
    case "future":
      logo_url = "/images/brand/search/alliance_logo.png";
      break;
    case "corestaff":
      logo_url = "/images/brand/search/alliance_logo.png";
      break;
    case "pei":
      logo_url = "/images/brand/search/alliance_logo.png";
      break;
    case "partner":
      logo_url = "/images/brand/search/partner_logo.png";
    default:
      logo_url = "/images/no_img.png";
      break;
  }
  return <Image width="70px" src={logo_url} />;
};
